
import angular from "angular";

import Assert from "tbAssert";
import TrackerBaseReportsConstants from "./Constants";
import ReportConfiguration from "./ReportConfiguration";
import DependencyListBuilder from "../../utility/DependencyListBuilder";

import StateEventCountReportController from "./StateEventCountReportController";

const reportConfiguration = new ReportConfiguration({
    reportDisplayName: "State Event Count Summary",
    reportStateName: "stateEventCount"
});


function StateEventCountReportConfiguration($stateProvider) {
    Assert.StrictAssert($stateProvider != null, "Assertion Failure: Missing UI Router State Provider Dependency");

    $stateProvider.state(
        `${TrackerBaseReportsConstants.rootStateName}.${reportConfiguration.stateName}`,
        {
            url: "/state-event-count",
            template: StateEventCountReportController.template,
            controller: StateEventCountReportController,
            controllerAs: StateEventCountReportController.controllerAs
        }
    );
}

StateEventCountReportConfiguration.$inject = [ "$stateProvider" ];

StateEventCountReportConfiguration.dependencies = [
    "ui.router"
];

const stateEventCountReportModuleDependencies = DependencyListBuilder([
    StateEventCountReportController.dependencies,
    StateEventCountReportConfiguration.dependencies
]);

export default {
    moduleName: angular
                    .module(
                        "trackerbase-app.views.trackerbase-reports.state-event-count-report",
                        stateEventCountReportModuleDependencies
                    )
                    .config(StateEventCountReportConfiguration)
                    .name,
    configs: [ reportConfiguration ]
};



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-reports/StateEventCountReport.js
// module id = YHGt
// module chunks = 1